<template>
  <div class="mes">
    <headd :mobile_title="mobile_title"></headd>
    <div class="kv">
      <img src="../../../static/message/kv.png" />
    </div>

    <div class="message container" v-if="msg_list">
      <div class="msg_list">
        <div class="msg_item" @click="goNotice">
          <div class="msg_icon">
            <img src="../../../static/message/icon_1.png" />
            <div class="text_1">通知</div>
          </div>
          <div class="msg_text">
            <div class="text_2">{{ msg_list.znlastmsg }}</div>
          </div>
          <div class="msg_right">
            <div class="msg_time">{{ msg_list.znlasttime }}</div>
            <div class="msg_count" v-if="msg_list.znmsgnum > 0">
              {{ msg_list.znmsgnum | indexsum }}
            </div>
          </div>
        </div>
      </div>
      <div class="msg_list" v-for="(item, i) in msg_list.friends">
        <div class="msg_item" @click="goNotice_2(item.uid, item.friend_id)">
          <div class="msg_icon">
            <img
              :src="
                item.favatarUrl != ''
                  ? item.favatarUrl
                  : '../../../static/user/icon_1.png'
              "
            />
            <div class="text_1">{{ item.fnickname }}</div>
          </div>
          <div class="msg_text">
            <div class="text_2">{{ item.lastmsg }}</div>
          </div>
          <div class="msg_right">
            <div class="msg_time">{{ item.lasttime }}</div>
            <div class="msg_count" v-if="item.newmsgnum > 0">
              {{ item.newmsgnum | indexsum }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <foot></foot>
  </div>
</template>

<script>
import headd from "@/components/head";
import foot from "@/components/foot";
import { getdialog } from "../api/api"; //引入api里面定义的方法
export default {
  data() {
    return {
      msgsmsgtimer: null,
      mobile_title: "消息",
      //imgURL: getApp().globalData.imgURL,
      msg_list: {},
      dialogFormVisible_3: true
    };
  },
  mounted() {
    this.getmsgs();
    this.msgstimedemo();
  },
  destroyed() {
    this.msgsmsgtimer && this.clearmsgsTimer();
  },
  metaInfo: {
    title: "马上创业网 专注企业注册的网站", // set a title
    meta: [
      {
        // set meta
        name: "keyWords",
        content:
          "马上创业网，注册公司，代理记账，上海注册公司，注册公司流程，注册公司费用，商标注册，法务咨询，法律服务，个体工商户注册，许可证办理，专业法律，社保，公积金，专利申请，医疗器械许可证，ICP电信增值许可证，食品经营许可证，酒类经营许可证，餐饮服务许可证，道路运输许可证，广播电视节目许可证，海关资质，进出口许可证，商标设计，logo设计，VI设计，海报设计，包装设计，APP开发，微信运营，网站定制，版权服务，软件著作权，发明专利，外观设计专利，实用新型专利，商标转让，驳回复审，注销公司，股权变更，经营范围变更，股权协议，股权转让，劳务派遣"
      },
      {
        name: "description",
        content:
          "马上创业网是一个专为中小企业服务的综合平台，主要提供医疗器械服务、审计服务、知识产权服务、财税咨询、注册公司、代理记账、商标注册、专利申请、社保代理、法务代理等一站式的服务，借助移动互联网技术，改善并升级企业服务状态，实现了新形势下中小企业所需要的企业服务。"
      }
    ]
  },
  components: {
    headd,
    foot
  },
  methods: {
    goNotice() {
      this.$router.push({
        path: "notice"
      });
    },
    goNotice_2(uid, recipient_id) {
      const url = this.$router.resolve({
        path: "/chat",
        query: { uid: uid, recipient_id: recipient_id }
      });
      window.open(url.href, "_blank");
    },
    async getmsgs() {
      var _slef = this;
      var data = {
        uid: localStorage.getItem("userId")
      };
      const res = await getdialog(data);
      //console.log(res)
      _slef.msg_list = res.data.data;
    },
			msgstimedemo() {
				this.msgsmsgtimer = setInterval(() => {
			
					this.getmsgs()
			
				}, 1500)
			},
			clearmsgsTimer() {
				clearInterval(this.msgsmsgtimer);
				this.msgsmsgtimer = null;
			},
  },
  onShow() {
    this.getmsgs();
  },
  onPullDownRefresh() {
    this.getmsgs();
    setTimeout(() => {
      uni.stopPullDownRefresh();
    }, 1000);
  }
};
</script>

<style lang="less" scoped>
.mes {
}
.kv {
  width: 100%;
  margin-bottom: 0.3rem;
  img {
    width: 100%;
  }
}
.message {
  flex-direction: column;
  width: 8rem;
  @media (max-width: 991px) {
    width: 6.86rem;
    margin: auto;
    padding: 0;
    .container {
      padding: 0;
    }
  }

  .msg_list {
    width: 100%;
    .msg_item {
      cursor: pointer;
      width: 100%;
      padding: 0.2rem 0.32rem;
      align-items: center;
      border-bottom: 0.01rem solid rgba(196, 196, 204, 0.1);
      display: flex;
      justify-content: space-between;
      @media (max-width: 991px) {
        padding: 0.2rem 0;
      }

      .msg_icon {
        margin-right: 1rem;
        border-radius: 50%;
        width: 1.4rem;

        img {
          width: 0.54rem;
          height: 0.54rem;
          border-radius: 50%;
          margin-bottom: 0.1rem;
          @media (max-width: 991px) {
            width: 0.8rem;
            height: 0.8rem;
          }
        }
        @media (max-width: 991px) {
          margin-right: 0.5rem;
        }
        .text_1 {
          color: #1b1c33;
          @media (max-width: 991px) {
            font-size: 0.26rem;
          }
        }
      }

      .msg_text {
        flex-direction: column;
        width: ~"calc(100% - 2.2rem)";
        text-align: left;
        .text_1 {
          font-size: 0.3rem;
          color: #1b1c33;
          @media (max-width: 991px) {
            font-size: 0.28rem;
          }
        }

        .text_2 {
          font-size: 0.18rem;
          color: #000;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
          -webkit-line-clamp: 1;
          @media (max-width: 991px) {
            font-size: 0.28rem;
            line-height: 0.36rem;
          }
        }
      }

      .msg_right {
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 1.3rem;
        .msg_time {
          font-size: 0.16rem;
          color: #8d8e99;
          @media (max-width: 991px) {
            font-size: 0.26rem;
          }
        }

        .msg_count {
          width: 0.2rem;
          height: 0.2rem;
          background: #ff0000;
          border-radius: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 0.14rem;
          color: #fff;
          margin-left: 0.4rem;
        }
      }
    }
  }
}
@media (max-width: 991px) {
  .head_line {
    border-bottom: 0rem solid #ccc;
    padding-bottom: 0rem !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/message/message.vue